export default __webpack_public_path__ + "9b33df34bcda2268081768ed8e92e0ab.png";